'use strict';

const eventDateHelper = require('friartux/components/eventDateHelper');
const cookieHelper = require('friartux/components/cookieHelper');
const { CLASSES } = require('friartux/utils/globals');

const SELECTORS = {
    body: 'body',
    ftoModalTrigger: '.js-fto-btn',
    ftoModal: '.fto-modal',
    ftoContainer: '.js-fto-container',
    ftoGetStartedBtn: '.js-fto-get-started',
    ftoAvailDateLabel: '.js-fto-date-label',
    checkedFtoAvailDateInput: '.js-fto-date:checked',
    setFtobtn: '.js-set-fto',
    unsetFtobtn: '.js-unset-fto',
    backBtn: '.js-back-btn',
    eventDateContainer: '.js-event-date-container',
    ftoExitModal: '#tryOnExitModal',
    expiredCookiesModal: '.js-fto-expired-cookie-modal',
    changeDateBtn: '.js-fto-change-date',
    availableDatesContainer: '.js-fto-available-date-container',
    addServiceFtoCardCtaContainer: '.js-fto-card-cta',
    addServiceFtoCardBtn: '.js-fto-card-btn'
};

function init() {
    $(SELECTORS.ftoGetStartedBtn).on('click', handleFtoGetStartedBtn);
    $(SELECTORS.ftoAvailDateLabel).on('keyup', handleFtoAvailDateLabel);
    $(SELECTORS.setFtobtn).on('click', handleSetFtobtn);
    $(SELECTORS.unsetFtobtn).on('click', handleUnsetFtobtn);
    $(SELECTORS.body).on('click', SELECTORS.backBtn, handleBackBtn);
    $(SELECTORS.body).on('click', SELECTORS.changeDateBtn, handleChangeDate);
    handleFtoCard();
    handleExpiredCookie();
}

const handleFtoGetStartedBtn = () => {
    $(SELECTORS.ftoModal)
        .find('.step-1').addClass(CLASSES.hide);
    $(SELECTORS.ftoModal)
        .find('.step-2').removeClass(CLASSES.hide);

    $(SELECTORS.ftoModal)
        .removeClass('lg-modal')
        .addClass('md-modal');

    $(SELECTORS.backBtn).removeClass(CLASSES.hide);
}

const handleFtoAvailDateLabel = (e) => {
    const $this = $(e.target);
    if (e.key === 'Enter' || e.key === 'Space' || e.key === ' ') {
        $this.trigger('click');
    }
}

const handleSetFtobtn = (e) => {
    const $this = $(e.target);
    const $container = $(SELECTORS.ftoContainer);

    const sitePreferences = window.SitePreferences;
    const ftoCookieSettings = sitePreferences.FTO_COOKIE_SETTINGS;

    const ftoMode = $container.data('mode');
    cookieHelper.setCookie('ftoMode', ftoMode, (ftoCookieSettings.ftoDateExpiration / 24));

    const ftoRegNo = $container.data('reg-no');
    cookieHelper.setCookie('ftoRegNo', ftoRegNo, (ftoCookieSettings.ftoRegNoExpiration / 24));

    const ftoType = $container.data('type');
    cookieHelper.setCookie('ftoType', ftoType, (ftoCookieSettings.ftoTypeExpiration / 24));

    const ftoDate = $(SELECTORS.checkedFtoAvailDateInput).val();
    cookieHelper.setCookie('ftoDate', ftoDate, (ftoCookieSettings.ftoDateExpiration / 24));

    // Set event date
    let eventDate = new Date(ftoDate);
    eventDate = $.datepicker.formatDate('mm/dd/yy', eventDate)

    $.when(
        eventDateHelper.setDate($(SELECTORS.eventDateContainer).data('url'), eventDate)
    )
    .done(() => {
        const href = $this.data('href');
        if (href) {
            window.location = $this.data('href');
        } else {
            window.location.reload();
        }
    });
}

const handleUnsetFtobtn = (e) => {
    const $this = $(e.target);
    const unsetUrl = $this.data('unset-url');
    cookieHelper.deleteCookie('ftoMode');
    cookieHelper.deleteCookie('ftoRegNo');
    cookieHelper.deleteCookie('ftoType');
    cookieHelper.deleteCookie('ftoDate');

    $(SELECTORS.ftoExitModal).spinner().start();

    $.ajax({
        url: unsetUrl,
        method: 'GET',
        dataType: 'json',
        success:  function (data) {
            $.spinner().stop();

            if (data.success) {
                window.location.reload();
            }
        }
    });
}

const handleBackBtn = () => {
    $(SELECTORS.ftoModal)
        .find('.step-1').removeClass(CLASSES.hide);
    $(SELECTORS.ftoModal)
        .find('.step-2').addClass(CLASSES.hide);

    $(SELECTORS.backBtn).addClass(CLASSES.hide);

    $(SELECTORS.ftoModal)
        .addClass('lg-modal')
        .removeClass('md-modal');
}

function handleExpiredCookie() {
    const $expiredCookiesModal = $(SELECTORS.expiredCookiesModal);

    if ($expiredCookiesModal.length) {
        $expiredCookiesModal.modal('show');
    }

    $(SELECTORS.body).on('hidden.bs.modal', SELECTORS.expiredCookiesModal, () => {
        const redirectUrl = $expiredCookiesModal.find('.b-form-actions a').first().attr('href');
        window.location = redirectUrl;
    });
}

function handleFtoCard() {
    const $ftoModal = $(SELECTORS.ftoModal);
    let $addServiceFtoCardBtn = $(SELECTORS.addServiceFtoCardBtn);
    if ($addServiceFtoCardBtn.length && $ftoModal.length) {
        const greenBtnClasses = 'f-button f-button--green';
        $addServiceFtoCardBtn.
            removeClass(greenBtnClasses)
            .addClass('underlined')
            .attr('target', '_blank');

        let $getStartedBtn = $('<button type="button" class="d-block mb-2">Get Started</button>');
        $getStartedBtn.addClass(greenBtnClasses);
        $getStartedBtn.on('click', () => {
            $(SELECTORS.ftoModalTrigger).trigger('click');
        });

        $(SELECTORS.addServiceFtoCardCtaContainer).prepend($getStartedBtn);
    }
}

const handleChangeDate = () => {
    const url = $(SELECTORS.availableDatesContainer).data('url');

    $(SELECTORS.availableDatesContainer).spinner().start();
    $.ajax({
        url: url,
        method: 'GET',
        success:  function (data) {
            $(SELECTORS.availableDatesContainer).spinner().stop();
            $(SELECTORS.availableDatesContainer).html(data)
        }
    });
}

module.exports = {
    init: init
};
